export enum ErrorCode {
    SUCCESS,
    TIMEOUT,
    ERROR
}

export enum RequestState {
    WAIT,
    SUCCESS,
    FAIL
}

export enum MethodType {
    GET = "get",
    POST = "post",
    PUT = "put",
    DELETE = "delete"
}

export enum RequestContentType {
    JSON,
    FORM
}

export enum ContentType {
    JSON = "application/json; charset=utf-8",
    FORM = "application/x-www-form-urlencoded",
    FORM_DATA = "multipart/form-data"
}

export interface RspInfo {
    code: string;//错误码
    msg: string;//错误信息
}

export interface ResponseProp {
    rspInfo: RspInfo; //错误码块
    data: any; //业务数据块
} 

export interface ErrorInfo {
    errorCode: ErrorCode;
    msg: string
}